
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getHomeStatAssets } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
@Component
export default class PiOrderEchart extends Vue {
  private pileEchart: objAny = {};
  private myChart: objAny = {};
  private statAssets: objAny = {};
  private win: objAny = window;
  @Prop({
    default: () => {
      return {};
    }
  })
  private formInline!: objAny;
  public init(): void {
    this.$nextTick(() => {
      this.pileEchart = this.$refs["pileEchart"];
      this.getHomeStatAssets();
    });
  }
  async getHomeStatAssets(): Promise<void> {
    const params = {
      merchantPkId: this.formInline.merchantPkId,
      oprPkId: this.formInline.oprPkId,
      regionId: this.formInline.regionId,
      staPkId: this.formInline.staPkId
    };
    const ret = await getHomeStatAssets(params);
    if (ret.status === this.$config.apiStatus) {
      this.statAssets = ret.data[0];
      this.echartShow();
    }
  }
  public echartShow(): void {
    const option = {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      color: ["#f7ba2a", "#20a0ff"],
      series: [
        {
          name: i18n.t("operationData.pileChartTitle"),
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: [
            {
              value: this.statAssets.acPileCount,
              name: i18n.t("operationData.pileChartAc")
            },
            {
              value: this.statAssets.dcPileCount,
              name: i18n.t("operationData.pileChartDc")
            }
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }
      ]
    };
    this.myChart = this.win.echarts.init(this.pileEchart);
    this.myChart.clear();
    this.myChart.setOption(option, true);
  }
}
